var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowTag = function SvgArrowTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 62 104"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A28",
    d: "M0 104V0h4.947l57.051 50.968L4.947 104z"
  })));
};
export default SvgArrowTag;